import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-img-title',
  templateUrl: './img-title.component.html',
  styleUrls: ['./img-title.component.css']
})
export class ImgTitleComponent implements OnInit {

  @Input() imgTitle_params: any = {}

  constructor() { }

  ngOnInit(): void {
  }

}
